import { ProfileState } from "./types"

export const initialProfileState: ProfileState = {
	authenticated: false,
	accessToken: ''
}
